import { typecastRouteProps } from "shared/helpers/routing";

export default [
  {
    component: () => import("pages/AutoTranscribe.vue"),
    meta: {
      title: "Auto Transcribe - Radio",
    },
    name: "radio-auto-transcribe",
    path: "/radio-auto-transcribe",
    props: (route) => ({ medium: "Radio", ...route.params, ...route.query }),
  },
  {
    component: () => import("pages/RadioStationList.vue"),
    meta: {
      title: "Radio Stations",
    },
    name: "radio-stations-list",
    path: "/radio-stations",
    props: (route) => typecastRouteProps(route),
  },
  {
    component: () => import("pages/RadioStationEdit.vue"),
    meta: {
      title: "New Radio Station",
    },
    name: "radio-stations-new",
    path: "/radio-stations/new",
  },
  {
    component: () => import("pages/RadioStationEdit.vue"),
    meta: {
      title: "Edit Radio Station",
    },
    name: "radio-stations-edit",
    path: "/radio-stations/:id",
    props: true,
  },
  {
    component: () => import("pages/RadioStationSchedule.vue"),
    meta: {
      title: "Edit Radio Station",
    },
    name: "radio-stations-schedule",
    path: "/radio-stations/:id/schedule",
    props: true,
  },
  {
    component: () => import("pages/RadioClipList.vue"),
    meta: {
      title: "Radio Clips",
    },
    name: "radio-clips-list",
    path: "/radio-clips",
    props: true,
  },
  {
    component: () => import("pages/RadioProgramList.vue"),
    meta: {
      title: "Radio Programs",
    },
    name: "radio-programs-list",
    path: "/radio-programs",
    props: ({ query }) => ({ query }),
  },
  {
    component: () => import("pages/RadioProgramEdit.vue"),
    meta: {
      title: "New Radio Program",
    },
    name: "radio-programs-new",
    path: "/radio-programs/new",
    props: (route) => ({ ...route.params, ...route.query }),
  },
  {
    component: () => import("pages/RadioProgramEdit.vue"),
    meta: {
      title: "Edit Radio Program",
    },
    name: "radio-programs-edit",
    path: "/radio-programs/:id",
    props: (route) => ({ ...route.params, ...route.query }),
  },
  {
    component: () => import("pages/radio/RadioPlayerPage.vue"),
    meta: {
      title: "Radio Player",
    },
    name: "radio-player",
    path: "/radio-player",
    props: (route) => ({ ...route.params, ...route.query }),
  },
  {
    component: () => import("pages/RadioMediaRequestEdit.vue"),
    meta: {
      title: "New Radio Media Item",
    },
    name: "radio-media-requests-new",
    path: "/radio-media-requests/new",
  },
  {
    component: () => import("pages/RadioMediaRequestEdit.vue"),
    meta: {
      title: "Edit Radio Media Item",
    },
    name: "radio-media-requests-edit",
    path: "/radio-media-requests/:radioMediaRequestId/edit",
    props: true,
  },
  {
    component: () => import("pages/radio/RadioClipList.vue"),
    meta: {
      accessLevel: "content_removal",
      title: "Radio Clips List",
    },
    name: "radio-clips",
    path: "/radio-clips-list",
    props: true,
  },
  {
    component: () =>
      import("src/modules/BroadcastStory/pages/BroadcastStoryList/BroadcastStoryList.vue"),
    meta: {
      title: "Radio Stories List",
    },
    name: "radio-stories",
    path: "/radio-stories",
    props: () => ({ broadcastType: "Radio" }),
  },
  {
    component: () =>
      import("src/modules/BroadcastStory/pages/BroadcastStoryPage/BroadcastStoryPage.vue"),
    meta: {
      title: "Radio Story Page",
    },
    name: "radio-stories-page",
    path: "/radio-stories/:id",
    props: true,
  },
];
